module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/target02-e5420ba6a98f2967b64b2753123d3107.png";